import { ca } from '@cian/analytics';

import { createCianAnalyticsPageWithExtra } from 'shared/utils/createCianAnalyticsPageWithExtra';
import { TDeviceType } from '@cian/ui-kit';

interface IParameters {
  query: string;
  totalSuggest: string;
  url: string;
  deviceType: TDeviceType;
  isDuplicateSuggest: boolean;
}

export function trackSearchSubmit({ query, totalSuggest, url, deviceType, isDuplicateSuggest }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'search_string',
    action: 'click',
    label: url,
    page: createCianAnalyticsPageWithExtra({
      deviceType,
      extra: {
        clickType: 'button',
        searchQuery: query,
        suggestCount: totalSuggest,
        isDuplicateSuggest: isDuplicateSuggest.toString(),
      },
    }),
  });
}
